import { Slot } from "@radix-ui/react-slot";
import { LinkWrapper, } from "../components/LinkWrapper";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
export const HOVERABLE_VARIANTS = [
    "invisible",
    "primary",
    "highlight",
];
const hoverableVariants = {
    invisible: cn("hover:text-highlight-light", "active:text-highlight-dark"),
    primary: cn("font-medium", "text-foreground", "hover:text-highlight-light", "active:text-highlight-dark"),
    highlight: cn("font-medium", 
    // highlight-700 instead of highlight (500): 500 is 3.2:1 on white, below
    // the 4.5:1 WCAG AA floor for body text; 700 passes in both themes (the
    // dark theme inverts the scale, mapping 700 to blue-300).
    "text-highlight-700", "hover:text-highlight-light", "active:text-highlight-dark"),
};
const variantStyle = cva("cursor-pointer duration-200 hover:underline hover:underline-offset-2", {
    variants: {
        variant: hoverableVariants,
    },
    defaultVariants: {
        variant: "invisible",
    },
});
const MetaHoverable = React.forwardRef(({ className, variant, asChild = false, children, ...props }, ref) => {
    const Comp = asChild ? Slot : "span";
    return (React.createElement(Comp, { className: cn(variant && variantStyle({ variant }), className), ref: ref, ...props }, children));
});
MetaHoverable.displayName = "MetaHoverable";
/**
 * An inline text element that reveals interactivity on hover — underline plus
 * a highlight color shift. Renders a link when `href` is set, otherwise a
 * clickable span for `onClick` handlers.
 *
 * Use `variant="highlight"` for link-colored text, `primary` for
 * foreground-colored labels that light up on hover, and the default
 * `invisible` for text that only shows affordance when hovered. For a real
 * button with padding and variants, use Button instead.
 *
 * @summary Inline hover-underlined text link or trigger.
 */
const Hoverable = React.forwardRef(({ href, target, rel, children, variant, className, ...props }, ref) => {
    const innerElement = (React.createElement(MetaHoverable, { ref: ref, variant: variant, className: className, ...props }, children));
    return href ? (React.createElement(LinkWrapper, { href: href, target: target, rel: rel }, innerElement)) : (innerElement);
});
Hoverable.displayName = "Hoverable";
export { Hoverable };
//# sourceMappingURL=Hoverable.js.map